import { CardMenuEleicaoComponent } from './../card-menu-eleicao/card-menu-eleicao.component';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CardMenuFinanceiroComponent } from '../card-menu-financeiro/card-menu-financeiro.component';
import { CardMenuPlanosComponent } from '../card-menu-planos/card-menu-planos.component';
import { CardMenuAdministrativoComponent } from '../card-menu-administrativo/card-menu-administrativo.component';
import { CardMenuPessoalComponent } from '../card-menu-pessoal/card-menu-pessoal.component';
import { CardMenuInstitucionalComponent } from '../card-menu-institucional/card-menu-institucional.component';


const cardsRoutes = [
    { path: 'cardMenuFinanceiro', component: CardMenuFinanceiroComponent },
    { path: 'cardMenuPlanos', component: CardMenuPlanosComponent },
    { path: 'cardMenuAdministrativo', component: CardMenuAdministrativoComponent },
    { path: 'cardMenuPessoal', component: CardMenuPessoalComponent },
    { path: 'cardMenuInstitucional', component: CardMenuInstitucionalComponent },
    { path: 'cardMenuEleicao', component: CardMenuEleicaoComponent }
];

@NgModule({
    imports: [RouterModule.forChild(cardsRoutes)],
    exports: [RouterModule]
})
export class CardMenuRoutingModule {
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/card-menu/router/card-menu.router.ts